import Isikukood, { Gender } from "isikukood";

export default function initLoginStatus() {
  // Call the function to check login status initially
  checkLoginStatus();

  function getCurrentLanguage() {
    // Try to get the language from the Polylang JavaScript object if available
    if (typeof pll_current_language !== "undefined") {
      return pll_current_language;
    }

    // Fallback: Try to get language from the HTML lang attribute
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
      // Extract the language code (e.g., 'en' from 'en-US')
      return htmlLang.split("-")[0];
    }

    return "et"; // Default to Estonian if no language found
  }

  function checkLoginStatus() {
    const currentLang = getCurrentLanguage();
    // Add language parameter to the API request
    fetch(`/wp-json/estravel/v1/check-login-status?lang=${currentLang}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        try { // header does not exist inside iframe form
          updateHeader(data);
        } catch (e) {}
        // userinfo contains only first and last name - get email and phone
        if (data.logged_in && sessionStorage.getItem("logged_in_user") === null) {
          fetch(`/api/customerinfo`, {
            headers: {
              'Authentication-Estravel': 'Bearer ' + data.logged_in_user.access_token
            }
          }).then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          }).then((userinfo) => {
            // Store user data in sessionStorage
            // E-mail > Business E-mail
            let email = userinfo.contacts.toSorted((a, b) => b.priority - a.priority).find(x => x.billing_allowed == 1 && ["E-mail", "Business E-mail"].includes(x.name)).value ?? '';
            // Mobile Phone > Phone > Business Mobile > Business Phone
            let phone = userinfo.contacts.toSorted((a, b) => b.priority - a.priority).find(x => ["Mobile Phone", "Phone", 'Business Mobile', 'Business Phone'].includes(x.name)).value ?? '';
            phone = '+' + phone;
            let customer_card = userinfo.customer_cards.toSorted((a, b) => ["Platinum Club", "Kuldkaart"].indexOf(a.card_type_name) - ["Platinum Club", "Kuldkaart"].indexOf(b.card_type_name))[0].customer_card_no ?? '';
            let isikukood = new Isikukood(userinfo.personal_code);
            let gender = '';
            let dobYMD = '';
            if (isikukood.validate()) {
              let dob = isikukood.getBirthday();
              dobYMD = dob.getFullYear() +
                '-' + String(dob.getMonth() + 1).padStart(2, '0') +
                '-' + String(dob.getDate()).padStart(2, '0');
              isikukood.getGender() === Gender.MALE ? 'M' : 'F'
            } else {
              console.warn("Invalid Estonian ID code: " . isikukood);
            }

            let user_info_expose = {
              'firstname': userinfo.firstname,
              'lastname': userinfo.lastname,
              'email': email,
              'phone': phone,
              'client_card': customer_card,
              'gender': gender,
              'dob': dobYMD,
            };
            sessionStorage.setItem("logged_in_user", JSON.stringify(user_info_expose));
          }).catch((error) => {
            console.error("Error getting user info:", error);
          });
        } else if (! data.logged_in) {
          sessionStorage.removeItem("logged_in_user");
        }

      })
      .catch((error) => {
        console.error("Error checking login status:", error);
      });
  }

  function updateHeader(data) {
    const userMenuText = document.getElementById("user-menu-text");
    const userDropdownContent = document.getElementById(
      "user-dropdown-content"
    );
    const userButton = document.getElementById("user");
    if (!userMenuText || !userDropdownContent || !userButton) {
      return;
    }

    if (data.logged_in) {
      userMenuText.innerHTML = `
        <span class="hidden xs:inline-block animate-text-opacity">${data.given_name} ${data.family_name}</span>
        <span class="block ml-6 xs-down:mr-10 e5-dropdown-icon xs-down:mt-1">
          <span class="block w-10 h-10 text-blue-800 pointer-events-none xs:text-yellow-400">
            ${data.chevron_icon}
          </span>
        </span>
      `;
      userDropdownContent.innerHTML = data.dropdown_html;

    } else {
      userMenuText.innerHTML = `
        <span class="hidden xs:inline-block animate-text-opacity">${data.login_string}</span>
        <span class="hidden xs:block ml-6 e5-dropdown-icon xs-down:mt-1">
          <span class="block w-10 h-10 text-blue-800 pointer-events-none xs:text-yellow-400">
            ${data.chevron_icon}
          </span>
        </span>
      `;
      userDropdownContent.innerHTML = data.dropdown_html;
    }

    // Remove existing event listener before adding a new one
    userButton.removeEventListener("click", toggleDropdown);
    userButton.addEventListener("click", toggleDropdown);
  }

  function toggleDropdown() {
    const userDropdownContent = document.getElementById(
      "user-dropdown-content"
    );
    userDropdownContent.classList.toggle("hidden");
  }
}
